// this file is generated by update_shopify_store_data.py at 2026-11-03 20:16:25.776642
var courses = [];